//
const initState: any = {}
const scriptLibrary = (
  state = initState,
  action: {
    group: any
    type: any
  },
) => {
  switch (action.type) {
    case "UPDATE_GROUP_INFO":
      return { ...state, group: action.group }
    default:
      return state
  }
}

export default scriptLibrary
